import { render, staticRenderFns } from "./EmProduct.vue?vue&type=template&id=5b44f3a0&scoped=true&"
import script from "./EmProduct.vue?vue&type=script&lang=js&"
export * from "./EmProduct.vue?vue&type=script&lang=js&"
import style0 from "./EmProduct.vue?vue&type=style&index=0&id=5b44f3a0&lang=scss&scoped=true&"
import style1 from "./EmProduct.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b44f3a0",
  null
  
)

component.options.__file = "EmProduct.vue"
export default component.exports